/* eslint-disable no-unneeded-ternary */
import React from 'react'
import ElementContainer from '../ElementContainer'
import { Chip, Box } from '@mui/material'

import { multiButtonSelectionStyles } from '../../../styles/classes/MobilePreviewClasses'

const MultiButtonSelection = ({
  title,
  helpfulHint,
  buttonsList,
  selectionType,
  onChangeValue,
  answer,
  isMandatory,
  disabled
}) => {
  const [multiAnswer, setMultiAnswer] = React.useState(answer ?? buttonsList?.map(() => null))

  const buttonTapHandler = index => {
    if (selectionType === 'single_selection') {
      const updatedArray = buttonsList.map((_, idx) => {
        if (index === idx) {
          if (multiAnswer[idx] === true) return null
          return true
        } else return null
      })
      setMultiAnswer(updatedArray)
      onChangeValue(updatedArray)
    } else {
      const updatedArray = [...multiAnswer]
      if (updatedArray[index] === true) updatedArray[index] = null
      else updatedArray[index] = true
      setMultiAnswer(updatedArray)
      onChangeValue(updatedArray)
    }
  }

  const { classes } = multiButtonSelectionStyles()
  const itemButton = (button, index) => {
    const selected = multiAnswer[index]
    let styles = selected ? classes.chipStylesSelected : classes.chipStyles
    if (disabled) styles = classes.disabledChipStyles
    if (disabled && selected) {
      styles = classes.chipPreviewModeStyles
    }
    return (
      <Chip
        key={`${button}-${index}`}
        className={styles}
        label={button}
        variant="outlined"
        onClick={() => buttonTapHandler(index)}
        disabled={disabled}
      />
    )
  }

  return (
    <ElementContainer
      title={title}
      helpfulHint={helpfulHint}
      isMandatory={isMandatory}
    >
      <Box className={classes.container}>
        {buttonsList.map((button, index) => itemButton(button, index))}
      </Box>
    </ElementContainer>
  )
}

export default MultiButtonSelection
